import { toast } from "sonner";
import { ApiError } from "@/lib/apiClient";

export function toastApiError(
  e: unknown,
  fallback = "Something went wrong. Please try again.",
): void {
  if (e instanceof ApiError && e.errorCode === "ERR_CANCELED") return;
  const message =
    e instanceof ApiError || e instanceof Error ? e.message : fallback;
  toast.error(message && message.trim() ? message : fallback);
}
